import {api} from './api';
import { User } from '../model/user';
import { Group } from '../model/group';

export const getGroups = async (accessToken: string): Promise<Group[]> => {
    const response = await api.get<Group[]>(`/groups`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    
    return response.data as Group[];
};

export const createGroups = async (accessToken: string, groupNames: string[]): Promise<boolean> => {
    const response = await api.post<boolean>(`/groups`, groupNames, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.status == 200
};

export const deleteGroup = async (accessToken: string, groupId: string): Promise<boolean> => {
    const response = await api.delete<boolean>(`/groups/${groupId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.status == 204 || response.status == 200
};

export const getGroupUsers = async (accessToken: string, groupId: string): Promise<User[]> => {
    const response = await api.get<User[]>(`/groups/${groupId}/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.data;
}

export const addGroupUsers = async (accessToken: string, groupId: string, userIds: string[]): Promise<boolean> => {
    const response = await api.post(`/groups/${groupId}/users`, userIds, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.status == 200
}

export const deleteGroupUser = async (accessToken: string, groupId: string, userId: string): Promise<boolean> => {
    const response = await api.delete(`/groups/${groupId}/users/${userId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })
    
    return response.status == 204 || response.status == 200
}